<template>
  <div class="container-relatorio">
    <div class="container-tipos-relatorios">
      <label
          @click="selecionarTipoRelatorio(1)"
          :class="{'item-relatorio item-selecionado' : tipoRelatorio === 1, 'item-relatorio item-no-select': tipoRelatorio !== 1}">Relação
        de cobranças</label>
      <label
          @click="selecionarTipoRelatorio(2)"
          :class="{'item-relatorio item-selecionado' : tipoRelatorio === 2, 'item-relatorio item-no-select': tipoRelatorio !== 2}">Relação
        de pagamentos</label>
    </div>
    <relatorio-cobrancas-geral v-if="tipoRelatorio === 1"/>
    <relatorio-pagamentos-geral v-if="tipoRelatorio === 2"/>
  </div>
</template>

<script>
import RelatorioCobrancasGeral from '@/views/pages/relatorios/cobranca/RelatorioCobrancasGeral.vue'
import RelatorioPagamentosGeral from '@/views/pages/relatorios/cobranca/RelatorioPagamentosGeral.vue'

export default {
    name: 'RelatorioCobranca',
    components: {RelatorioPagamentosGeral, RelatorioCobrancasGeral},
    data() {
        return {
            tipoRelatorio: 1,
        }
    },
    methods: {
        selecionarTipoRelatorio(tipo) {
            this.tipoRelatorio = tipo
        }
    }

}
</script>

<style scoped lang="stylus">

</style>